import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  IconButton,
  Paper,
  Typography,
  Grid,
  Button,
  Divider,
  Container,
  Stack,
  Dialog,
  useMediaQuery,
} from "@mui/material";
import OurModels from "./OurModels";
import MicIcon from "@mui/icons-material/Mic";
import { useNavigate } from "react-router-dom";
import { HeroSection } from "../StyledComponents";
import FeaturedPodcasts2 from "./PodcastToplist";
import StartPageFAQSection from "../StartPageFAQSection";

import MyContentDash from "./MyContentDash";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import {
  MenuBook as BookIcon,
  Psychology as BrainIcon,
  Layers as LayersIcon,
  AssignmentTurnedIn as ClipboardIcon,
  SmartToy as BotIcon,
  AccessibilityNew as AccessibilityIcon,
  Create as CreateIcon,
  List as ListIcon,
  School as SchoolIcon,
  Chat as ChatIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { VideoPlayer } from "./HelpDialogItems";
import OnboardingProgress from "./OnboardingProgress";
import LanguageIcon from "@mui/icons-material/Language";

import SmartToyIcon from "@mui/icons-material/SmartToy";
import Highlights from "./Highlights";
import MessageIcon from "@mui/icons-material/Message";

import { motion } from "framer-motion";
import SummarizeIcon from "@mui/icons-material/Summarize";

import VibrantBluePodcastBox from "./VibrantBluePodcastBox";
import QuantumNeuralMatrixMUI from "./QuantumNeuralMatrixMUI";
import HelpContent from "./HelpContent";
import MyContent from "./MyContent";
import WeeklyFeatures from "./WeeklyFeatures";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import SwitchLessonsDrawer from "./SwitchLessonsDrawer";
import GenerateIcon from "@mui/icons-material/AutoAwesome";

import PlayCircleIcon from "@mui/icons-material/PlayCircle";

import Groups2Icon from "@mui/icons-material/Groups2";
import CreateClassDialog from "./CreateClassDialog";
import NetworkCheckIcon from "@mui/icons-material/NetworkCheck";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MenuOpenIcon from "@mui/icons-material/MenuBook";

import ConstructionIcon from "@mui/icons-material/Construction";
import UsageBox from "./UsageBox";
import NotesIcon from "@mui/icons-material/Notes";
import HelpDialog from "./HelpDialog";
import CurrentSection from "./CurrentSection";
import ViewAgendaIcon from "@mui/icons-material/ViewAgenda";
import QuizIcon from "@mui/icons-material/Quiz";

import PeopleIcon from "@mui/icons-material/People";

import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";

import AddCircleIcon from "@mui/icons-material/AddCircle";

import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import EventNoteIcon from "@mui/icons-material/EventNote";
import PowerPointIcon from "./PowerPointIcon";
import { Grading as GradingIcon } from "@mui/icons-material";

import LessonBankDialog from "./LessonBankDialog";
import { TableChart as TableChartIcon } from "@mui/icons-material";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";

import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import DashboardIcon from "@mui/icons-material/Dashboard";
import QuizBank from "./QuizBank";
import FlashcardsBank from "./FlashcardsBank";
import ImageBank from "./ImageBank";

import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";

import FolderOpenIcon from "@mui/icons-material/FolderOpen";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import PlayArrowIcon from "@mui/icons-material/PlayArrow";
const videoUrl = "https://sportkuriren.se/wp-content/uploads/bibel-tabell.mp4";
const posterUrl = "https://sportkuriren.se/wp-content/uploads/bibel-tabell.png";

import { db } from "./firebase";
import { useAuth } from "./useAuth";
import {
  collection,
  addDoc,
  deleteDoc,
  getDocs,
  getDoc,
  query,
  where,
  doc,
  onSnapshot,
} from "firebase/firestore";

const SegmentedNavigation = ({ user, styles, theme, role }) => {
  const [activeSection, setActiveSection] = useState(null);
  const navigate = useNavigate();
  const [videoDialogOpen, setVideoDialogOpen] = useState(false);
  const [isCreateClassDialogOpen, setIsCreateClassDialogOpen] = useState(false);
  const [switchLessonDrawerOpen, setSwitchLessonDrawerOpen] = useState(false);
  const [openImageBank, setOpenImageBank] = useState(false);
  const [openFlashcardsBank, setOpenFlashcardsBank] = useState(false);
  const [openLessonBank, setOpenLessonBank] = useState(false);
  const [openVideoDialog, setOpenVideoDialog] = useState(false);
  const [openOverviewDialog, setOpenOverviewDialog] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [openQuizVideoDialog, setOpenQuizVideoDialog] = useState(false);
  const [openFlashcardsVideoDialog, setOpenFlashcardsVideoDialog] =
    useState(false);
  const [openGradingVideoDialog, setOpenGradingVideoDialog] = useState(false);
  const [openAssistentVideoDialog, setOpenAssistentVideoDialog] =
    useState(false);

  const [openPodcastDialog, setOpenPodcastDialog] = useState(false);

  const [openQuizBank, setOpenQuizBank] = useState(false);

  const handleActionClick = (path) => {
    // You could add custom logic here before navigation
    navigate(path);
    // navigate(path);
  };

  const [shouldCenter, setShouldCenter] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current) {
        const hasOverflow =
          containerRef.current.scrollWidth > containerRef.current.clientWidth;
        setShouldCenter(!hasOverflow);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, []);
  const sections = [
    {
      id: "assessments",
      title: "Bedömning",
      icon: GradingIcon,
      description: "Hantera bedömningar",
      subsections: [
        {
          name: "Ny bedömning",
          icon: AddCircleIcon,
          path: "/app/uppsats/ny",
        },
        {
          name: "Ny matris",
          icon: AddCircleIcon,
          path: "/app/matris/ny",
        },

        ...(role !== "student"
          ? [
              {
                name: "Ny klass",
                icon: AddCircleIcon,
                path: "skapa-ny-klass",
              },
              {
                name: "Mina klasser",
                icon: SchoolIcon,
                path: "/app/klasser",
              },
            ]
          : []),
        {
          name: "Mina bedömningar",
          icon: FolderOpenIcon,
          path: "/app/uppsatser",
        },
        {
          name: "Mina matriser",
          icon: DashboardIcon,
          path: "/app/matris/mina",
        },

        {
          name: "Så funkar det",
          icon: PlayArrowIcon,
          path: "helpdialog-bedomning",
        },
      ],
      color: {
        main: "linear-gradient(to bottom right, #F97316, #EA580C)",
        hover: "linear-gradient(to bottom right, #EA580C, #C2410C)",
        light: "#FFF7ED2b", // Amber-50 equivalent
        accent: "#D97706", // Amber-600 equivalent
        text: "#B45309", // Amber-700 equivalent
        gradient: "#efefef75",
      },
    },

    {
      id: "lessons",
      title: "Lektioner",
      path: "/app/lektioner",
      icon: SchoolIcon,
      description: "Skapa och hantera lektioner",
      subsections: [
        {
          name: "Generera lektioner",
          icon: AutoFixHighIcon,
          path: "/app/lektioner",
        },

        {
          name: "Mina lektioner",
          icon: FolderOpenIcon,
          path: "/app/delade-lektioner",
        },
        //{ name: "Lektionsbanken", icon: DashboardIcon, path: "lektionsbanken" },

        {
          name: "Så funkar det",
          icon: PlayArrowIcon,
          path: "helpdialog-lektioner",
        },
      ],
      color: {
        main: "linear-gradient(to bottom right, #9333EA, #7E22CE)",
        hover: "linear-gradient(to bottom right, #7E22CE, #6B21A8)",
        light: "#F5F3FF2b", // Indigo-50 equivalent
        accent: "#6D28D9", // Indigo-600 equivalent
        text: "#3B82F6", // Indigo-700 equivalent
        gradient: "#efefef75",
      },
    },

    {
      id: "quiz",
      title: "Quiz",
      icon: BrainIcon,
      description: "Generera och hantera quiz",
      subsections: [
        { name: "Generera quiz", icon: AutoFixHighIcon, path: "/app/quiz" },
        // { name: "Quiz-banken", icon: DashboardIcon, path: "quizbanken" },
        { name: "Mina quiz", icon: FolderOpenIcon, path: "/app/mina-quiz" },
        {
          name: "Så funkar det",
          icon: PlayArrowIcon,
          path: "helpdialog-quiz",
        },
      ],
      color: {
        main: "linear-gradient(to bottom right, #9F1239, #881337)",
        hover: "linear-gradient(to bottom right, #881337, #4C0519)",
        light: "#FFF1F22b",
        accent: "#9F1239",
        text: "#9333EA",
        gradient: "#efefef75",
      },
    },

    {
      id: "podcast",
      title: "Podcast",
      icon: MicIcon,
      description: "Generera podcasts med AI",
      subsections: [
        {
          name: "Generera podcast",
          icon: AutoFixHighIcon,
          path: "/app/podcast",
        },
        // { name: "Quiz-banken", icon: DashboardIcon, path: "quizbanken" },
        {
          name: "Mina podcasts",
          icon: FolderOpenIcon,
          path: "/app/mina-podcasts",
        },
        {
          name: "Så funkar det",
          icon: PlayArrowIcon,
          path: "helpdialog-podcast",
        },
      ],
      color: {
        main: "linear-gradient(to bottom right, #9F1239, #881337)",
        hover: "linear-gradient(to bottom right, #881337, #4C0519)",
        light: "#FFF1F22b",
        accent: "#9F1239",
        text: "#5760c4",
        gradient: "#efefef75",
      },
    },
    {
      id: "flashcards",
      title: "Flashcards",
      icon: ViewAgendaIcon,
      description: "Skapa och öva med flashcards",
      subsections: [
        {
          name: "Generera flashcards",
          icon: AutoFixHighIcon,
          path: "/app/flashcards",
        },
        // {
        //   name: "Flashcards-banken",
        //   icon: DashboardIcon,
        //   path: "flashcardsbanken",
        // },
        {
          name: "Mina flashcards",
          icon: FolderOpenIcon,
          path: "/app/mina-flashcards",
        },
        {
          name: "Så funkar det",
          icon: PlayArrowIcon,
          path: "helpdialog-flashcards",
        },
      ],
      color: {
        main: "linear-gradient(to bottom right, #22C55E, #16A34A)",
        hover: "linear-gradient(to bottom right, #16A34A, #15803D)",
        light: "#ECFDF52b", // Emerald-50 equivalent
        accent: "#059669", // Emerald-600 equivalent
        text: "#047857", // Emerald-700 equivalent
        gradient: "#efefef75",
      },
    },

    {
      id: "ai",
      title: "Assistenter",
      icon: BotIcon,
      description: "Använd AI-verktyg",
      subsections: [
        {
          name: "Skapa AI-assistent",
          icon: PersonAddAltIcon,
          path: "/app/larare",
        },
        {
          name: "Ämnen",
          icon: SchoolIcon,
          path: "/app/personal",
        },

        {
          name: "Lär dig språk",
          icon: LanguageIcon,
          path: "/app/sprak",
        },

        {
          name: "Chatta med böcker",
          icon: LibraryBooksIcon,
          path: "/app/bocker",
        },

        { name: "Chat", icon: ChatIcon, path: "/app/fraga-ai" },
        {
          name: "Så funkar det",
          icon: PlayArrowIcon,
          path: "helpdialog-assistent",
        },
      ],
      color: {
        main: "linear-gradient(to bottom right, #EF4444, #DC2626)",
        hover: "linear-gradient(to bottom right, #DC2626, #B91C1C)",
        light: "#FEF2F22b", // Rose-50 equivalent
        accent: "#E11D48", // Rose-600 equivalent
        text: "#BE123C", // Rose-700 equivalent
        gradient: "#efefef75",
      },
    },

    {
      id: "aids",
      title: "Hjälpmedel",
      icon: ConstructionIcon,
      description: "Verktyg och hjälpmedel för lärande",
      subsections: [
        ...(role === "teacher"
          ? [
              {
                name: "Generera bilder",
                icon: AddPhotoAlternateIcon,
                path: "/app/generera-bild",
              },
              {
                name: "Bildbanken",
                icon: PhotoLibraryIcon,
                path: "bildbanken",
              },
            ]
          : []),

        { name: "Bildanalys", icon: ImageSearchIcon, path: "/app/vision" },

        ...(role === "teacher"
          ? [
              {
                name: "Lektionsplanering",
                icon: EventNoteIcon,
                path: "/app/lektioner/lektionsplan",
              },
              {
                name: "Generera PowerPoint",
                icon: PowerPointIcon,
                path: "/app/generera-powerpoint",
              },
            ]
          : []),

        {
          name: "Skapa begreppslista",
          icon: NotesIcon,
          path: "/app/fraga-ai?p=vocabulary",
        },
        {
          name: "Skriv e-post",
          icon: AlternateEmailIcon,
          path: "/app/fraga-ai?p=email",
        },
        { name: "Skapa en egen kurs", icon: MenuOpenIcon, path: "/app/kurser" },
        {
          name: "Förklara för mig",
          icon: MenuOpenIcon,
          path: "/app/fraga-ai?p=explain",
        },
        {
          name: "Rollspel",
          icon: PeopleIcon,
          path: "/app/fraga-ai?p=roleplay",
        },
        {
          name: "Debatt",
          icon: QuestionAnswerIcon,
          path: "/app/fraga-ai?p=debate",
        },
      ],
      color: {
        main: "linear-gradient(to bottom right, #1E3A8A, #172554)",
        hover: "linear-gradient(to bottom right, #172554, #0F172A)",
        light: "#EFF6FF2b",
        accent: "#1E3A8A",
        text: "#0F172A",
        gradient: "#efefef75",
      },
    },
  ];

  const [hiddenMenus, setHiddenMenus] = useState([]);

  // Add this useEffect using the existing user data
  useEffect(() => {
    if (!user?.uid || !user?.rooms) return;

    async function fetchRoomShortcuts() {
      // If user has rooms, get shortcuts from the first one
      if (user.rooms && user.rooms.length > 0) {
        try {
          const roomDoc = await getDoc(doc(db, "rooms", user.rooms[0]));
          if (roomDoc.exists()) {
            setHiddenMenus(roomDoc.data()?.shortcuts || []);
          }
        } catch (error) {
          console.error("Error fetching room:", error);
        }
      }
    }

    fetchRoomShortcuts();
  }, [user]);

  const handleClassCreated = async (newClass) => {
    navigate(`/app/klasser/${newClass.id}`);

    setIsCreateClassDialogOpen(false);
  };

  const handleSectionClick = (sectionId, section) => {
    //navigate(section.path);
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const handleSubsectionClick = (path) => {
    if (path === "bildbanken") {
      setOpenImageBank(true);
    } else if (path === "skapa-ny-klass") {
      setIsCreateClassDialogOpen(true);
    } else if (path === "quizbanken") {
      setOpenQuizBank(true);
    } else if (path === "lektionsbanken") {
      setSwitchLessonDrawerOpen(true);
    } else if (path === "flashcardsbanken") {
      setOpenFlashcardsBank(true);
    } else if (path === "helpdialog-lektioner") {
      setOpenOverviewDialog(true);
    } else if (path === "helpdialog-bedomning") {
      setOpenGradingVideoDialog(true);
    } else if (path === "helpdialog-quiz") {
      setOpenQuizVideoDialog(true);
    } else if (path === "helpdialog-flashcards") {
      setOpenFlashcardsVideoDialog(true);
    } else if (path === "helpdialog-assistent") {
      setOpenAssistentVideoDialog(true);
    } else if (path === "helpdialog-podcast") {
      setOpenPodcastDialog(true);
    } else {
      navigate(path);
    }
  };

  return (
    <Box sx={{ p: 0, minHeight: "80vh" }}>
      {/* Paper container for the segmented control */}
      {/* Compact Tabbed Navigation */}

      <HeroSection
        elevation={0}
        role={role}
        sx={{ p: { xs: 2, md: 5 }, display: { xs: "none", md: "none" } }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h2"
            component="h1"
            sx={{
              fontWeight: 600,
              textAlign: "center",
              fontSize: { xs: "1.3rem", md: "2.2rem" },
              mb: { xs: 0, md: 2 },
            }}
          >
            Välkommen, {user.displayName}!
          </Typography>
          <Box
            sx={{
              fontSize: { xs: "0.9rem", md: "1rem" },
              width: { xs: "100%", md: "100%" },
              color: "#dddddd",
              textAlign: "center",
              fontWeight: 500,
              display: { xs: "none", md: "none" },
            }}
          >
            Klicka på valfri genväg nedan eller{" "}
            <Button
              component="span"
              sx={{
                color: "white",
                cursor: "pointer",
                fontWeight: 500,
                textDecoration: "none",
                textTransform: "none",
                fontSize: "0.9rem",
                padding: "0px",
                pt: { xs: 0.2, md: 0.5 },
                pb: { xs: 0.2, md: 0.5 },
                pl: 1.3,
                pr: 1.3,
                mb: 0.3,
                borderRadius: 3,
                backgroundColor: "#ffffff24",
                minWidth: "auto",
                "&:hover": {
                  textDecoration: "underline",
                  backgroundColor: "#ffffff24",
                  color: "white",
                },
              }}
              onClick={(e) => {
                e.stopPropagation(); // Prevent event bubbling
                setOpenOverviewDialog(true);
                //navigate("/app/guide");
              }}
            >
              utforska alla sätt
            </Button>{" "}
            som du kan använda Studera.ai.
          </Box>
        </Container>
      </HeroSection>

      <Box
        sx={{
          display: { xs: "none", md: "block" },
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Box
          component="h2"
          sx={{
            fontSize: 25,
            fontWeight: "600",
            color: "text.primary",
            m: 0,
          }}
        >
          Välkommen, {user.displayName}!
        </Box>
      </Box>
      <Box
        sx={{
          mb: 3,
          fontSize: "1.01rem",
          width: { xs: "100%", md: "100%" },
          color: "text.secondary",
          display: "none",
        }}
      >
        Klicka på valfri genväg nedan eller{" "}
        <Box
          component="span"
          sx={{
            color: "primary.main",
            cursor: "pointer",
            fontWeight: 500,
            textDecoration: "none",
            display: "inline",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          onClick={() => setOpenOverviewDialog(true)}
        >
          utforska alla sätt
        </Box>{" "}
        som du kan börja använda Studera.ai.
      </Box>

      <Box
        sx={{
          display: { xs: "none", md: "none" },
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
          mt: 7,
        }}
      >
        <Box
          component="h2"
          sx={{
            fontSize: 25,
            fontWeight: "600",
            color: "text.primary",
            m: 0,
          }}
        >
          Vad vill du generera idag?
        </Box>
      </Box>

      <Box
        sx={{
          position: "relative",
          display: "none",
          mb: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            borderRadius: 3,
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
            mb: 3,
            overflowX: "auto",
            overflowY: "hidden",
            //position: "relative",
            background:
              theme.palette.themeType === "allakando"
                ? "linear-gradient(105deg, rgb(121, 162, 33) 0%, rgba(121, 162, 33, 0.95) 50%, rgba(121, 162, 33, 0.98) 100%)"
                : user.accountType === "student"
                  ? "linear-gradient(105deg, rgba(148, 163, 126, 1) 0%, rgba(120, 134, 107, 0.95) 50%, rgba(101, 116, 88, 0.98) 100%)"
                  : "linear-gradient(105deg, rgba(139, 92, 246, 1) 0%, rgba(147, 51, 234, 0.95) 50%, rgba(139, 92, 246, 0.98) 100%)",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "linear-gradient(45deg, rgba(255,255,255,0.15) 0%, transparent 75%)",
              clipPath: "polygon(100% 0, 100% 100%, 0 100%, 50% 0)",
            },

            flexWrap: "nowrap",
            width: "100%",
          }}
        >
          {" "}
          {isMobile && (
            <div
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                width: "60px",
                background:
                  "linear-gradient(to right, transparent, rgba(255,255,255,0.5))",
                pointerEvents: "none",
                zIndex: 100,
                borderTopRightRadius: "0.75rem",
                borderBottomRightRadius: "0.75rem",
              }}
            />
          )}
          {sections.map((section) => {
            if (role === "student" && section.title === "Lektioner") return;
            if (role === "teacher" && section.title === "Hjälpmedel") return;

            const isActive = activeSection === section.id;
            return (
              <Box
                key={section.id}
                onClick={() => handleSectionClick(section.id, section)}
                sx={{
                  flex: "0 0 auto",
                  width: { xs: "130px", sm: "100px", md: "auto" },
                  flexBasis: { md: "0", lg: "0" },
                  flexGrow: { md: 1, lg: 1 },
                  position: "relative",
                  py: { xs: 2, md: 3 },
                  px: { xs: 2, md: 1.5 },
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                  bgcolor: isActive ? "rgb(240 248 255 / 14%)" : "transparent",
                  "&:hover": {
                    bgcolor: isActive
                      ? section.color.light
                      : "rgba(94, 53, 177, 0.2)",
                    "& .section-title": {
                      borderBottom: "2px solid white",
                    },
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <section.icon
                    sx={{
                      color: "white",
                      fontSize: { xs: 29, sm: 28, md: 40 },
                      mb: 1,
                    }}
                  />
                  <Typography
                    className="section-title"
                    sx={{
                      color: "white",
                      fontSize: { xs: "1rem", sm: "0.8rem", md: "1rem" },
                      fontWeight: 600,
                      textAlign: "center",
                      paddingBottom: "4px",
                      borderBottom: "2px solid transparent",
                      transition: "border-color 0.2s",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {section.title}
                  </Typography>
                  <Box sx={{ display: "none" }}>
                    <KeyboardArrowDownIcon
                      sx={{
                        color: isActive ? section.color.text : "text.primary",
                      }}
                    />
                  </Box>
                </Box>
                {isActive && (
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: "25%",
                      width: "50%",
                      height: 3,
                      borderTopLeftRadius: 3,
                      borderTopRightRadius: 3,
                      bgcolor: section.color.accent,
                    }}
                  />
                )}
              </Box>
            );
          })}
        </Box>
      </Box>

      <>
        <Box
          sx={{
            display: { xs: "flex", md: "flex" },
            justifyContent: "space-between",
            alignItems: "center",
            mb: 0,
            mt: 7,
            display: "none",
          }}
        >
          <Box
            component="h2"
            sx={{
              fontSize: 25,
              width: "100%",
              textAlign: "center",
              fontWeight: "600",
              color: "text.primary",
              m: 0,
            }}
          >
            Vad vill du generera idag?
          </Box>
        </Box>
        <Box
          sx={{
            mt: 2,

            pl: 1,
            pr: 1,
            borderRadius: 4,
            backgroundColor: theme.palette.mode === "dark" ? "#1d2c3c" : "#fff",
            backgroundImage: "none",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
            animation: "fadeIn 0.4s ease forwards",
            "@keyframes fadeIn": {
              "0%": { opacity: 0, transform: "translateY(10px)" },
              "100%": { opacity: 1, transform: "translateY(0)" },
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Box sx={{ width: { xs: "100%", md: "100%" } }}>
              <Box
                sx={{
                  width: "100%",
                  // display: "flex",
                  display: "none",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <GenerateIcon
                  sx={{ color: "text.secondary", display: "none" }}
                />
                <Box
                  component="h3"
                  sx={{
                    fontSize: 18,
                    fontWeight: "600",
                    color: "text.secondary",
                    mb: 3,
                    mt: 0,
                  }}
                >
                  Genvägar:
                </Box>
              </Box>
              <Box
                ref={containerRef}
                sx={{
                  display: "flex",
                  flexWrap: "nowrap",
                  justifyContent: shouldCenter ? "center" : "flex-start",
                  gap: 2,
                  overflowX: "auto",
                  overflowY: "visible",
                  pb: 0, // RIGHT HERE - changed from pb: 1
                  WebkitOverflowScrolling: "touch",
                  msOverflowStyle: "none",
                  scrollbarWidth: "none",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  position: "relative",
                }}
              >
                {[
                  ...(hiddenMenus.includes("bedomning")
                    ? []
                    : [
                        {
                          id: "assessments",
                          title: "Bedömning",
                          icon: ClipboardIcon,
                          color: "#b45309",
                          path: "/app/uppsats/ny",
                        },
                      ]),
                  {
                    id: "quiz",
                    title: "Quiz",
                    icon: BrainIcon,
                    color: "#9333EA",
                    path: "/app/quiz",
                  },
                  {
                    id: "lessons",
                    title: "Lektioner",
                    icon: SchoolIcon,
                    color: "#3B82F6",
                    path: "/app/lektioner",
                  },

                  {
                    id: "flashcards",
                    title: "Flashcards",
                    icon: ViewAgendaIcon,
                    color: "#22C55E",
                    path: "/app/flashcards",
                  },
                  // Conditionally include podcast menu item
                  ...(hiddenMenus.includes("podcast")
                    ? []
                    : [
                        {
                          id: "podcast",
                          title: "Podcast",
                          icon: MicIcon,
                          color: "#5760c4",
                          path: "/app/podcast",
                        },
                      ]),
                  // Conditionally include chat menu item
                  // ...(hiddenMenus.includes("chat")
                  //   ? []
                  //   : [
                  //       {
                  //         id: "chat",
                  //         title: "Chat",
                  //         icon: ChatIcon,
                  //         color: "#EF4444",
                  //         path: "/app/fraga-ai",
                  //       },
                  //     ]),
                  // Conditionally include assessment menu item

                  {
                    id: "aids",
                    title: "Hjälpmedel",
                    icon: EventNoteIcon,
                    color: "#0f172a",
                    path: "/app/lektioner/lektionsplan",
                  },
                  // Conditionally include assistants menu item
                  ...(hiddenMenus.includes("assistenter")
                    ? []
                    : [
                        {
                          id: "ai",
                          title: "Assistenter",
                          icon: SmartToyIcon,
                          color: "#EF4444",
                          path: "/app/larare",
                        },
                      ]),
                ]
                  .filter((action) => {
                    if (
                      role === "student" &&
                      (action.title === "Lektioner" ||
                        action.title === "Lektionsplan" ||
                        action.title === "Mina lektioner" ||
                        action.title === "PowerPoint" ||
                        action.title === "Prov")
                    ) {
                      return false;
                    }

                    if (
                      role === "teacher" &&
                      (action.title === "Ämnes-assistenter" ||
                        action.title === "Språk-assistenter" ||
                        action.title === "Mina flashcards" ||
                        action.title === "Chat" ||
                        action.title === "Mina quiz")
                    ) {
                      return false;
                    }
                    return true;
                  })
                  .map((action, index, filteredArray) => (
                    <Paper
                      key={action.title}
                      elevation={0}
                      onClick={() => handleSectionClick(action.id, action)}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 3,
                        paddingTop: 3,
                        paddingBottom: 3,
                        width: role === "teacher" ? 130 : 150,
                        borderRadius: 0,
                        cursor: "pointer",
                        backgroundColor:
                          theme.palette.mode === "dark"
                            ? activeSection === action.id
                              ? "#2a3f55"
                              : "#1d2c3c"
                            : activeSection === action.id
                              ? "#f9f9f9"
                              : "#fff",
                        position: "relative", // Add this for positioning the indicator

                        "&:hover": {
                          borderColor: "transparent",
                          backgroundColor:
                            theme.palette.mode === "dark"
                              ? "#192734"
                              : "#f9f9f9",
                        },
                        "&:hover .icon": {
                          transform: "scale(1.1) rotate(7deg)",
                          transition: "transform 0.3s ease",
                        },
                        "&:hover .text": {
                          fontWeight: 600,
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 60,
                          height: 60,
                          borderRadius: 70,
                          bgcolor: `${action.color}10`,
                        }}
                      >
                        <action.icon
                          className="icon"
                          sx={{
                            color: action.color,
                            fontSize: 32,
                            transition: "transform 0.3s ease",
                          }}
                        />
                      </Box>
                      <Box
                        className="text"
                        sx={{
                          fontWeight: activeSection === action.id ? 600 : 500,
                          fontSize: role === "teacher" ? "1rem" : "1rem",
                          textAlign: "center",
                          marginTop: 1.3,
                          transition: "transform 0.3s ease",
                        }}
                      >
                        {action.title}
                      </Box>
                      {/* Active state indicator */}
                      {activeSection === action.id && (
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            width: "100%",
                            height: 4,
                            backgroundColor: action.color,
                            borderRadius: "0 0 0 0",
                          }}
                        />
                      )}

                      {activeSection === action.id && !isMobile && (
                        <Box
                          sx={{
                            display: "none",
                            position: "absolute",
                            bottom: -12,
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: 0,
                            height: 0,
                            borderLeft: "12px solid transparent",
                            borderRight: "12px solid transparent",
                            borderTop: `12px solid ${action.color}`,
                            zIndex: 10,
                          }}
                        />
                      )}
                    </Paper>
                  ))}
              </Box>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  width: "120px",
                  background:
                    theme.palette.mode === "dark"
                      ? "linear-gradient(to right, transparent, rgba(0,0,0,0.6))"
                      : "linear-gradient(to right, transparent, rgba(255,255,255,0.9))",
                  pointerEvents: "none",
                  zIndex: 100,
                  borderTopRightRadius: "0.75rem",
                  borderBottomRightRadius: "0.75rem",
                }}
              />
            </Box>

            <Box
              sx={{
                width: { xs: "100%", md: "34%" },
                mt: { xs: 5, md: 7 },
                display: "none",
              }}
            >
              <Box
                sx={{ width: "100%" }}
                onClick={() => navigate("/app/podcast")}
              >
                {/*
                <QuantumNeuralMatrixMUI role={role} />
*/}

                <VibrantBluePodcastBox role={role} />
              </Box>
            </Box>
          </Box>
        </Box>
      </>
      {/* Subsections appear below when a section is active */}
      {activeSection && (
        <Box
          sx={{
            mt: 2.3,
            p: 3,
            borderRadius: 4,
            backgroundImage: "none",
            bgcolor: theme.palette.mode === "dark" ? "#283947" : "white",
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
            animation: "fadeIn 0.3s ease forwards",
            "@keyframes fadeIn": {
              "0%": { opacity: 0, transform: "translateY(10px)" },
              "100%": { opacity: 1, transform: "translateY(0)" },
            },
            position: "relative",
          }}
        >
          <Box
            sx={{
              // display: "flex",
              display: "none",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
              pb: 2,
              borderBottom: `2px solid ${sections.find((s) => s.id === activeSection).color.main}`,
            }}
          >
            <Box
              component="h2"
              sx={{
                fontSize: 20,
                fontWeight: "600",

                m: 0,
              }}
            >
              {sections.find((s) => s.id === activeSection).title}
            </Box>
            <IconButton
              onClick={() => setActiveSection(null)}
              sx={{
                p: 1,
                bgcolor: sections.find((s) => s.id === activeSection).color
                  .main,
                color: "text.secondary",
                "&:hover": {
                  bgcolor: sections.find((s) => s.id === activeSection).color
                    .hover,
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(2, 1fr)", // 1 column on extra small screens (mobile)
                md: "repeat(4, 1fr)", // 3 columns on medium screens and above
              },
              gap: 3,
            }}
          >
            {sections
              .find((s) => s.id === activeSection)
              .subsections.map((subsection, index) => {
                // Force all subsections to have the same animation behavior
                // Store whether it's a video guide in a variable
                const isVideoGuide = subsection.name === "Så funkar det";

                return (
                  <Box
                    key={`${activeSection}-${subsection.name}`}
                    component="button"
                    onClick={() => handleSubsectionClick(subsection.path)}
                    sx={{
                      // Base styling
                      p: 3,
                      pt: 0.5,
                      pb: 0.5,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 2,
                      border: "1px solid",
                      borderRadius: 3,
                      position: "relative",
                      overflow: "hidden",
                      cursor: "pointer",

                      borderColor:
                        theme.palette.mode === "dark"
                          ? "transparent" // No border in dark mode
                          : isVideoGuide
                            ? "#FFEDD5"
                            : "grey.100",
                      border: `1px solid ${"#3b82f6"}20`,
                      bgcolor:
                        theme.palette.mode === "dark"
                          ? "background.paper"
                          : "#f9f9f9",

                      // Conditional styling - non-animation related
                      background:
                        theme.palette.mode === "dark"
                          ? isVideoGuide
                            ? "#422800"
                            : "#1d2c3c"
                          : isVideoGuide
                            ? "#FFF7ED"
                            : sections.find((s) => s.id === activeSection).color
                                .gradient,

                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",

                      // Animation setup
                      opacity: 0,
                      transform: "translateY(20px)",
                      animation: "fadeInUp 0.4s ease forwards",
                      animationDelay: `${index * 0.1}s`,

                      // Improved transition for smooth hover effect
                      transition:
                        "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",

                      // Hover effect without !important
                      "&:hover": {
                        transform: "translateY(-5px) scale(1.03)",
                        boxShadow: "0 10px 15px rgba(0,0,0,0.08)",
                      },

                      // Animation keyframes
                      "@keyframes fadeInUp": {
                        from: {
                          opacity: 0,
                          transform: "translateY(20px)",
                        },
                        to: {
                          opacity: 1,
                          transform: "translateY(0)",
                        },
                      },
                    }}
                  >
                    {" "}
                    {isVideoGuide && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: 8,
                          right: 8,
                          bgcolor: "#F97316",
                          color: "white",
                          borderRadius: "12px",
                          fontSize: "0.7rem",
                          fontWeight: "bold",
                          px: 1.5,
                          py: 0.5,
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <PlayArrowIcon sx={{ fontSize: 16 }} />
                        Video
                      </Box>
                    )}
                    <Box
                      sx={{
                        // bgcolor: isVideoGuide
                        //   ? "rgba(249, 115, 22, 0.15)"
                        //   : sections.find((s) => s.id === activeSection).color
                        //       .light,
                        borderRadius: "50%",
                        p: 2,
                        pb: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          borderRadius: "100px",
                          bgcolor: isVideoGuide
                            ? "rgba(249, 115, 22, 0.15)"
                            : `${sections.find((s) => s.id === activeSection).color.text}10`,
                          p: 1.6,

                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <subsection.icon
                          sx={{
                            fontSize: 30,
                            color:
                              theme.palette.mode === "dark"
                                ? "white"
                                : isVideoGuide
                                  ? "#C2410C"
                                  : sections.find((s) => s.id === activeSection)
                                      .color.text,
                          }}
                        />
                      </Box>
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        fontWeight: isVideoGuide ? "600" : "500",
                        textAlign: "center",
                        color:
                          theme.palette.mode === "dark"
                            ? "white"
                            : isVideoGuide
                              ? "#C2410C"
                              : "black",
                      }}
                    >
                      {subsection.name}
                    </Typography>
                    <Typography sx={{}}>{subsection.description}</Typography>
                  </Box>
                );
              })}
          </Box>
        </Box>
      )}

      {user.school !== "roomStudent" && (
        <Box sx={{ mb: 5, mt: 8 }}>
          <MyContentDash user={user} styles={styles} role={role} />
        </Box>
      )}
      {/*
      {user.school !== "roomStudent" && (
        <Box sx={{ mb: 5, mt: 9 }}>

          <MyContent user={user} styles={styles} role={role} theme={theme} />
        </Box>
      )}
*/}
      {role === "teacher" && (
        <Box sx={{ mb: 5, mt: 11 }}>
          <OnboardingProgress userId={user.uid} styles={styles} theme={theme} />
        </Box>
      )}

      {role === "teacher" && (
        <Grid container spacing={3} sx={{ mt: 5 }}>
          {/* Right Paper - Activate for Students */}
          <Grid item xs={12} md={6}>
            <Paper
              sx={{
                background: "linear-gradient(to right, #3b82f6, #4f46e5)",

                padding: 4,
                mt: 5,
                color: "white",
                boxShadow: "none",
                borderRadius: 4,
                height: "300px",
                cursor: "pointer",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
                  "& .arrow-icon": {
                    opacity: 1,
                    transform: "translateX(5px)",
                  },
                },
                // Add display flex and center alignment for vertical centering
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={(e) => {
                navigate("/app/rum");
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  marginBottom: 3,
                  lineHeight: 1.4,
                  fontSize: 40,
                  textAlign: "center",
                }}
              >
                Aktivera för elever
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  marginBottom: 2,
                  textAlign: "center",
                  fontSize: "1.2rem",
                }}
              >
                Ge dina elever tillgång till Studera.AI
              </Typography>
              <Button
                disableElevation
                sx={{
                  backgroundColor: "white",
                  color: "#444",
                  fontWeight: 600,
                  fontSize: "1rem",
                  textAlign: "center",
                  pl: 3,
                  pr: 3,
                  mt: 4,
                  borderRadius: 3,
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#f9fafb",
                  },
                  ".MuiPaper-root:hover &": {
                    transform: "translateX(5px)",
                  },
                }}
                endIcon={
                  <ArrowForwardIcon
                    className="arrow-icon"
                    sx={{
                      transform: "translateX(0)",
                      transition: "opacity 0.3s ease, transform 0.3s ease",
                    }}
                  />
                }
              >
                Aktivera
              </Button>
            </Paper>
          </Grid>

          {/* Left Paper - Help Guide */}
          <Grid item xs={12} md={6}>
            <Paper
              sx={{
                background: "linear-gradient(to right, #10b981, #059669)",
                padding: 4,
                mt: 5,
                color: "white",
                boxShadow: "none",
                borderRadius: 4,
                height: "300px",
                cursor: "pointer",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
                  "& .arrow-icon": {
                    opacity: 1,
                    transform: "translateX(5px)",
                  },
                },
                // Add display flex and center alignment for vertical centering
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={(e) => {
                setOpenOverviewDialog(true);
                //navigate(`/app/guide`);
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  marginBottom: 3,
                  lineHeight: 1.4,
                  fontSize: 40,
                  textAlign: "center",
                }}
              >
                Hjälpguide
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  marginBottom: 2,
                  textAlign: "center",
                  fontSize: "1.2rem",
                }}
              >
                Se hur du använder Studera.AI
              </Typography>
              <Button
                disableElevation
                sx={{
                  backgroundColor: "white",
                  color: "#444",
                  fontWeight: 600,
                  fontSize: "1rem",
                  textAlign: "center",
                  pl: 3,
                  pr: 3,
                  // Remove the top margin as vertical centering is handled by the Paper container
                  mt: 4,
                  borderRadius: 3,
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    backgroundColor: "#f9fafb",
                  },
                  ".MuiPaper-root:hover &": {
                    transform: "translateX(5px)",
                  },
                }}
                endIcon={
                  <ArrowForwardIcon
                    className="arrow-icon"
                    sx={{
                      transform: "translateX(0)",
                      transition: "opacity 0.3s ease, transform 0.3s ease",
                    }}
                  />
                }
              >
                Utforska
              </Button>
            </Paper>
          </Grid>
        </Grid>
      )}

      {!user.rooms && (
        <>
          <Box sx={{ mb: 5, mt: 16 }}>
            <OurModels styles={styles} />
          </Box>
          <Box sx={{ mb: 5, mt: 16, display: "none" }}>
            <Highlights onActionClick={handleActionClick} role={role} />
          </Box>
        </>
      )}

      {!user.rooms && (
        <Box sx={{ mt: 15 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Paper
                sx={{
                  background: "linear-gradient(to right, #3b82f6, #4f46e5)",
                  padding: 4,
                  color: "white",
                  boxShadow: "none",
                  borderRadius: 4,
                  minHeight: "300px", // Changed from fixed height to minHeight
                  height: "auto", // Allow height to adjust based on content
                  cursor: "pointer",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  display: "flex", // Added flex display
                  flexDirection: "column", // Stack children vertically
                  "&:hover": {
                    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
                    "& .arrow-icon": {
                      opacity: 1,
                      transform: "translateX(5px)",
                    },
                  },
                }}
                onClick={(e) => {
                  navigate(`/app/hp/4miSuszFn20l91NdCMGB`);
                }}
              >
                <Box sx={{ flex: 1 }}>
                  {" "}
                  {/* Content wrapper with flex:1 */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      marginBottom: 1,
                      lineHeight: 1.4,
                      fontSize: { xs: 24, md: 33 }, // Responsive font size
                    }}
                  >
                    Öva på förra årets högskoleprov
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      marginBottom: 2,
                    }}
                  >
                    Med stöd från AI för att öka din förståelse
                  </Typography>
                </Box>
                <Button
                  disableElevation
                  sx={{
                    backgroundColor: "white",
                    color: "#444",
                    fontWeight: 600,
                    fontSize: "1rem",
                    pl: 3,
                    pr: 3,
                    mt: { xs: 2, md: 7 }, // Reduced top margin on mobile
                    borderRadius: 3,
                    alignSelf: "flex-start", // Align button to the left
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#f9fafb",
                    },
                    ".MuiPaper-root:hover &": {
                      transform: "translateX(5px)",
                    },
                  }}
                  endIcon={
                    <ArrowForwardIcon
                      className="arrow-icon"
                      sx={{
                        transform: "translateX(0)",
                        transition: "opacity 0.3s ease, transform 0.3s ease",
                      }}
                    />
                  }
                >
                  Till provet
                </Button>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper
                sx={{
                  background: "linear-gradient(to right, #121214, #27272a)",
                  padding: 4,
                  color: "white",
                  boxShadow: "none",
                  borderRadius: 4,
                  minHeight: "300px", // Changed from fixed height to minHeight
                  height: "auto", // Allow height to adjust based on content
                  cursor: "pointer",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  display: "flex", // Added flex display
                  flexDirection: "column", // Stack children vertically
                  "&:hover": {
                    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
                    "& .arrow-icon": {
                      opacity: 1,
                      transform: "translateX(5px)",
                    },
                  },
                }}
                onClick={(e) => {
                  navigate(`/app/hp/F8CaAdYcKBH0K7X5bhZX`);
                }}
              >
                <Box sx={{ flex: 1 }}>
                  {" "}
                  {/* Content wrapper with flex:1 */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      marginBottom: 1,
                      lineHeight: 1.4,
                      fontSize: { xs: 24, md: 33 }, // Responsive font size
                    }}
                  >
                    Kan du orden från senaste högskoleprovet?
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      marginBottom: 2,
                    }}
                  >
                    Testa dina kunskaper och förbättra ditt ordförråd
                  </Typography>
                </Box>
                <Button
                  disableElevation
                  sx={{
                    backgroundColor: "white",
                    color: "#333",
                    fontWeight: 600,
                    fontSize: "1rem",
                    pl: 3,
                    textTransform: "normal",
                    pr: 3,
                    mt: { xs: 2, md: 7 }, // Reduced top margin on mobile
                    borderRadius: 3,
                    alignSelf: "flex-start", // Align button to the left
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#f9fafb",
                    },
                    ".MuiPaper-root:hover &": {
                      transform: "translateX(5px)",
                    },
                  }}
                  endIcon={
                    <ArrowForwardIcon
                      className="arrow-icon"
                      sx={{
                        opacity: 0.7,
                        transform: "translateX(0)",
                        transition: "opacity 0.3s ease, transform 0.3s ease",
                      }}
                    />
                  }
                >
                  Testa nu
                </Button>
              </Paper>
            </Grid>
          </Grid>
          {/*
        <FeaturedPodcasts2 user={user} />
        */}
        </Box>
      )}

      <Box sx={{ mb: 5, mt: 16, display: "none" }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{
            mb: 1,
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          Vanliga frågor och svar
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            color: "text.secondary",
            textAlign: "center",
            mb: 4,
            fontSize: "1.1rem",
          }}
        ></Typography>

        <StartPageFAQSection student={role === "student"} />
      </Box>
      <Box sx={{ mt: 15, display: "none" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3,
          }}
        >
          <PlayCircleIcon
            sx={{
              mr: 1.5,
              color: "rgb(239 68 68)",
              fontSize: 30,
              display: "none",
            }}
          />
          <Box
            component="h2"
            sx={{
              fontSize: 24,
              fontWeight: "bold",
              color: "text.primary",
              m: 0,
            }}
          >
            Hjälpguide: Lär dig använda plattformen
          </Box>
        </Box>
        <HelpContent
          overview={true}
          boxShadow="0 4px 12px rgba(0, 0, 0, 0.05)"
          backgroundGradient="#076046"
          clipPathBackground=""
          insideApp={true}
          user={user}
        />
      </Box>
      <Box
        sx={{
          position: "relative",
          borderRadius: 2,
          overflow: "hidden",
          boxShadow: 5,
          background: "linear-gradient(to right, #3b0764, #5b21b6, #3b0764)",
          //background: "linear-gradient(to right, #1f2937, #312e81, #1f2937)",

          width: { xs: "100%", md: "60%" },
          display: "none",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(45deg, rgba(255,255,255,0.2) 0%, transparent 60%)",
            clipPath:
              "polygon(15% 0%, 100% 0%, 100% 100%, 85% 100%, 30% 40%, 0% 0%)",
          },
        }}
      >
        {/* Överlagring med gradient */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to top right, #000, transparent)",
            opacity: 0.2,
          }}
        />

        {/* Suddiga cirkulära element */}
        <Box
          sx={{
            position: "absolute",
            height: 128,
            width: 128,
            borderRadius: "50%",
            bgcolor: "#facc15",
            filter: "blur(64px)",
            opacity: 0.2,
            top: -40,
            left: -40,
          }}
        />

        <Box
          sx={{
            position: "absolute",
            height: 128,
            width: 128,
            borderRadius: "50%",
            bgcolor: "#93c5fd",
            filter: "blur(64px)",
            opacity: 0.2,
            bottom: -40,
            right: -40,
          }}
        />

        {/* Huvudinnehåll */}
        <Box sx={{ position: "relative", p: 5, pt: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography
              sx={{
                fontSize: 15,
                color: "#fff",
                bgcolor: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(4px)",
                px: 1.5,
                py: 0.5,
                borderRadius: 12,
                boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.1)",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                display: "none",
              }}
            >
              <NewReleasesIcon sx={{ mr: 0.5, fontSize: 16 }} />
              NYHET
            </Typography>

            <Stack
              direction="row"
              spacing={1.5}
              sx={{
                alignItems: "flex-end",
                justifyContent: "flex-end",
                display: "none",
              }}
            >
              <Box
                sx={{ width: 32, height: 4, borderRadius: 12, bgcolor: "#fff" }}
              />
              <Box
                sx={{
                  width: 12,
                  height: 4,
                  borderRadius: 12,
                  bgcolor: "rgba(255, 255, 255, 0.5)",
                }}
              />
              <Box
                sx={{
                  width: 12,
                  height: 4,
                  borderRadius: 12,
                  bgcolor: "rgba(255, 255, 255, 0.5)",
                }}
              />
            </Stack>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
            }}
          >
            {/* Bild-sektion */}
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                mb: { xs: 2, md: 0 },
              }}
            >
              <Box
                onClick={() => setVideoDialogOpen(true)}
                sx={{
                  cursor: "pointer",
                  position: "relative",
                  borderRadius: 4,
                  "&:hover": {
                    opacity: 0.9,
                  },
                }}
              >
                <img
                  src={posterUrl}
                  alt="Video thumbnail"
                  style={{ width: "100%", display: "block", borderRadius: 10 }}
                />
                <Box
                  className="play-button"
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    backgroundColor: "rgb(0 0 0 / 83%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "transform 0.2s",
                    pointerEvents: "none",
                    "&:hover": {
                      transform: "translate(-50%, -50%) scale(1.1)",
                    },
                  }}
                >
                  <PlayArrowIcon sx={{ color: "white", fontSize: "4rem" }} />
                </Box>
              </Box>
            </Box>

            {/* Text-sektion */}
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                pl: { md: 4 },
              }}
            >
              <Typography
                sx={{
                  display: "inline-block",
                  px: 1.5,
                  py: 0.5,
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                  backdropFilter: "blur(4px)",
                  borderRadius: 12,
                  fontSize: 12,
                  color: "#fff",
                  fontWeight: 600,
                  mb: 1,
                  display: "flex",
                  alignItems: "center",
                  width: "30%",
                }}
              >
                <NewReleasesIcon sx={{ mr: 0.5, fontSize: 18 }} />
                Nyhet
              </Typography>

              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: "#fff",
                  fontSize: 24,
                }}
              >
                Chatta med böcker
              </Typography>

              <Typography
                sx={{
                  mt: 1,
                  color: "rgba(255, 255, 255, 0.9)",
                }}
              >
                Assistenter med specialiserade kunskapsbaser med svar förankrat
                i originalverket.
              </Typography>

              <Stack direction="row" spacing={1.5} sx={{ mt: 3 }}>
                <Button
                  onClick={() => setVideoDialogOpen(true)}
                  variant="contained"
                  sx={{
                    bgcolor: "rgba(255, 255, 255, 0.2)",
                    backdropFilter: "blur(4px)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    color: "#fff",
                    py: 1,
                    px: 2.5,
                    borderRadius: 2,
                    textTransform: "none",
                  }}
                >
                  Se video
                </Button>

                <Button
                  sx={{
                    color: "#fff",
                    textTransform: "none",
                  }}
                  endIcon={<ArrowForwardIcon sx={{ fontSize: 16 }} />}
                  onClick={() => navigate("/app/bocker")}
                >
                  Prova nu
                </Button>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
      {!user.rooms && <Divider sx={{ mt: 12, mb: 4 }} />}
      <QuizBank
        open={openQuizBank}
        onClose={() => setOpenQuizBank(false)}
        user={user}
        styles={styles}
        theme={theme}
      />
      <ImageBank
        open={openImageBank}
        onClose={() => setOpenImageBank(false)}
        user={user}
        styles={styles}
        theme={theme}
      />
      <CreateClassDialog
        open={isCreateClassDialogOpen}
        onClose={() => setIsCreateClassDialogOpen(false)}
        onClassCreated={handleClassCreated}
        userId={user.uid}
      />
      <FlashcardsBank
        open={openFlashcardsBank}
        onClose={() => setOpenFlashcardsBank(false)}
        user={user}
        styles={styles}
        theme={theme}
      />
      <LessonBankDialog
        open={openLessonBank}
        onClose={() => setOpenLessonBank(false)}
        user={user}
        styles={styles}
        theme={theme}
      />
      <HelpDialog
        open={openOverviewDialog}
        onClose={() => setOpenOverviewDialog(false)}
        overview={true}
        user={user}
      />
      <HelpDialog
        open={openVideoDialog}
        onClose={() => setOpenVideoDialog(false)}
        quiz={false}
        flashcards={false}
        textLabbet={false}
        grading={false}
        powerpoint={false}
        assistent={false}
        user={user}
      />
      <HelpDialog
        open={openGradingVideoDialog}
        onClose={() => setOpenGradingVideoDialog(false)}
        quiz={false}
        flashcards={false}
        textLabbet={false}
        grading={true}
        powerpoint={false}
        assistent={false}
        user={user}
      />
      <HelpDialog
        open={openQuizVideoDialog}
        onClose={() => setOpenQuizVideoDialog(false)}
        quiz={true}
        flashcards={false}
        textLabbet={false}
        grading={false}
        powerpoint={false}
        assistent={false}
        user={user}
      />
      <HelpDialog
        open={openFlashcardsVideoDialog}
        onClose={() => setOpenFlashcardsVideoDialog(false)}
        quiz={false}
        flashcards={true}
        textLabbet={false}
        grading={false}
        powerpoint={false}
        assistent={false}
        user={user}
      />
      <HelpDialog
        open={openAssistentVideoDialog}
        onClose={() => setOpenAssistentVideoDialog(false)}
        quiz={false}
        flashcards={false}
        textLabbet={false}
        grading={false}
        powerpoint={false}
        assistent={true}
        user={user}
      />
      <HelpDialog
        open={openPodcastDialog}
        onClose={() => setOpenPodcastDialog(false)}
        quiz={false}
        flashcards={false}
        textLabbet={false}
        grading={false}
        powerpoint={false}
        assistent={false}
        podcast={true}
        user={user}
      />
      <SwitchLessonsDrawer
        open={switchLessonDrawerOpen}
        onClose={() => setSwitchLessonDrawerOpen(false)}
        user={user}
        styles={styles}
        theme={theme}
      />
      {/* Video Dialog */}
      <Dialog
        open={videoDialogOpen}
        onClose={() => setVideoDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { backgroundColor: "transparent" },
        }}
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            aria-label="close"
            onClick={() => setVideoDialogOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "white",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1,
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.7)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
          <VideoPlayer
            videoUrl={videoUrl}
            poster={posterUrl}
            autoPlay
            controls
          />
        </Box>
      </Dialog>
    </Box>
  );
};

export default SegmentedNavigation;
